import Child from './Child';

/*
 * Represents a object that can be described with attributes.
 */
class Noun extends Child {
  constructor(args = {}) {
    super(args);

    const {
      data = {},
    } = args;

    const {
      etag,
      ...restData
    } = data;

    this._etag = etag;

    this._attributeMap = {
      ...restData,
    };
  }

  // TODO: This needs to move out of here to somewhere good
  etag() {
    return this._etag;
  }

  export() {
    return {
      ...this._attributeMap,
    };
  }

  attr(key, value) {
    if (key === undefined) {
      throw new Error('Usage: Key is required.');
    }

    if (value === undefined) {
      return this._attributeMap[key];
    }

    this._attributeMap = {
      ...this._attributeMap,
      [key]: value,
    };

    return this;
  }

  deleteAttr(key) {
    if (key === undefined) {
      throw new Error('Usage: Key is required.');
    }
    delete this._attributeMap[key]
    return this;
  }

  attributes(attrs) {
    if (attrs === undefined) {
      return { ...this._attributeMap };
    }

    this._attributeMap = {
      ...this._attributeMap,
      ...attrs,
    };

    return this;
  }

  isTruthy(attrName) {
    return this.attr(attrName) === 'true';
  }

  id() {
    throw new Error('Must override.');
  }

  merge(otherThing) {
     if (!this.shouldMerge(otherThing)) {
      return;
    }

    this._attributeMap = {
      ...this._attributeMap,
      ...otherThing._attributeMap,
    };
    return this;
  }
}

export default Noun;
